module.exports = __webpack_public_path__ + "static/img/user1.4e6a4e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user1.png
// module id = gmOq
// module chunks = 1